import LINEAR_EQUATION from "./Questions/linear_equation";

export default function LINEAR_EQUATIONS() {
  return (
    <section id="linear_equations" className="grid gap-16">
      <LINEAR_EQUATION />
    </section>
  );
}
